// Components==============
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './index.module.scss';
// =========================

export default function SearchBar({
    searchValue,
    setSearchValue,
    dashboard,
    blueGray,
}) {
    function handleSubmit(e) {
        e.preventDefault();
    }

    return (
        <form
            onSubmit={handleSubmit}
            styleName={`form ${dashboard ? 'dashboard' : ''} ${
                blueGray ? 'blueGray' : ''
            }`}
        >
            <div>
                <input
                    type="text"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    placeholder="Zoeken"
                />
                <button type="submit">
                    <FontAwesomeIcon icon={faSearch} />
                </button>
            </div>
        </form>
    );
}
